<!-- @format -->

<template>
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col cols="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label>rank</label>
          <v-select v-model="rank" :options="perPageOptions" :clearable="false" style="width: 150px" class="per-page-selector d-inline-block ml-50 mr-1" />
        </b-col>
        <b-col cols="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label>时间</label>
          <v-select v-model="date_type" :options="score_time" :clearable="false" label="label" :reduce="item => item.value" style="width: 200px" class="per-page-selector d-inline-block ml-50 mr-1" />
        </b-col>
        <b-col cols="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label>是否结算</label>
          <v-select style="width: 150px" v-model="type" :options="score_type" :clearable="false" :reduce="item => item.value" class="per-page-selector d-inline-block ml-50 mr-1" />
        </b-col>
        <b-col cols="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label>类别:</label>
          <v-select style="width: 150px" v-model="cate" :options="score_cate" :clearable="false" :reduce="item => item.value" class="per-page-selector d-inline-block ml-50 mr-1" />
        </b-col>
        <b-col cols="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label>模式</label>
          <v-select style="width: 150px" v-model="log_type" :options="score_log_type" :reduce="item => item.value" :clearable="false" class="per-page-selector d-inline-block ml-50 mr-1" />
        </b-col>
      </b-row>
    </div>

    <b-table
      ref="refInvoiceListTable"
      :items="fetchInvoices"
      responsive
      striped
      :fields="tableColumns"
      primary-key="id"
      show-empty
      empty-text="暂无数据"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
      bordered
      :busy.sync="isLoading">
      <!--   条目ID   -->
      <template #cell(id)="data">
        <b-link class="font-weight-bold"> #{{ data.value }} </b-link>
      </template>

      <!--    品牌网址  -->
      <template #cell(url)="data">
        <b-link target="_blank" class="font-weight-bold" :href="data.value | filisHttp"> #{{ data.value }} </b-link>
      </template>

      <!--   状态   -->
      <!-- <template #cell(status)="data">
        <b-badge v-if="data.value == 1" variant="primary"> 已提交 </b-badge>
        <b-badge v-else-if="data.value == 2" variant="warning"> 已处理 </b-badge>
        <b-badge v-else variant="success"> 已生效 </b-badge>
      </template> -->
    </b-table>

    <div class="mx-2 mb-2">
      <b-row>
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
          <span class="text-muted">显示 {{ dataMeta.from }} 到 {{ dataMeta.to }} 条 {{ dataMeta.of }} 数据</span>
        </b-col>
        <!-- Pagination -->
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination v-model="currentPage" :total-rows="totalInvoices" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BButton, BTable, BLink, BBadge, BDropdown, BDropdownItem } from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { onUnmounted, ref, getCurrentInstance } from '@vue/composition-api'
import store from '@/store'
import useInvoicesList from './CommissionList'

import BrandManagerModule from './CommissionModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    vSelect,
    BBadge,
    BLink,
    BDropdown,
    BDropdownItem,
  },
  filters: {
    filisHttp(value) {
      return value.indexOf('http') > -1 ? value : `http://${value}`
    },
  },

  setup() {
    const INVOICE_APP_STORE_MODULE_NAME = 'commission-module'
    const popoverShow = ref(false)
    const { proxy } = getCurrentInstance()
    //
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, BrandManagerModule)
    // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    // })

    const setBrandDetail = data => {
      store.commit(`${INVOICE_APP_STORE_MODULE_NAME}/setBrandDetail`, data)
    }

    const {
      fetchInvoices,
      tableColumns,
      perPage,
      rank,
      score_time,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      isSortDirDesc,
      refInvoiceListTable,
      date_type,
      statusFilter,
      score_type,
      type,
      score_cate,
      cate,
      score_log_type,
      log_type,
      refetchData,
      isLoading,
      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
      confirmDelete,
    } = useInvoicesList(proxy)
    return {
      isLoading,
      fetchInvoices,
      tableColumns,
      perPage,
      date_type,
      currentPage,
      score_time,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      isSortDirDesc,
      refInvoiceListTable,
      statusFilter,
      score_type,
      type,
      refetchData,
      score_cate,
      cate,
      avatarText,
      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
      popoverShow,
      setBrandDetail,
      confirmDelete,
      score_log_type,
      log_type,
      rank,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.diy_center_td_table {
  ::v-deep .center_td {
    td {
      text-align: center !important;
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
